// extracted by mini-css-extract-plugin
module.exports = {"font-icon":"RowActionsColumn_font-icon__39STP"};